import React from 'react';
import { Box, GuideDot } from 'edenred-ui';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ICreateBenefitGroupForm } from '@epi-models/pages/BenefitGroups';
import { useOnboardingWizard } from '@epi-shared/hooks';
import { BenefitType } from '@epi-constants/benefitTypes';

export const AnnualLimitsGuideDot = () => {
  const { t } = useTranslation();
  const { isOnBoardingActive } = useOnboardingWizard();
  const { watch } = useFormContext<ICreateBenefitGroupForm>();
  const benefitSettings = watch('benefitSettings');
  const isAnyBenefitChecked = Object.entries(benefitSettings)
    .filter(([key]) => key !== BenefitType.Lunch)
    .some(([, benefit]) => !!benefit);

  if (!isOnBoardingActive || !isAnyBenefitChecked) {
    return null;
  }

  return (
    <Box position="absolute" top={-20} left={0}>
      <GuideDot
        storageKey="annual-limits-guide-dot"
        tooltipDescription={t('guided_tour.annual_limits')}
      />
    </Box>
  );
};
